import { render } from "./RaceInput.vue?vue&type=template&id=4853c4eb"
import script from "./RaceInput.vue?vue&type=script&lang=js"
export * from "./RaceInput.vue?vue&type=script&lang=js"

import "./RaceInput.vue?vue&type=style&index=0&id=4853c4eb&lang=css"

import exportComponent from "/builds/sites/smolke/app-kwispelcoach-com/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__